import React from "react";
import { format } from "date-fns";

const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
const Entry = ({ entry, deleteEntry }) => {
  const formatDate2 = (date) => {
    const d = date.split("-");
    return `${months[Number(d[1]) - 1]}. ${d[2]}, ${d[0]}`;
  };
  return (
    <tr>
      <td>{entry.examName}</td>
      <td>{entry.status}</td>
      <td>
        {entry.registrationDate && formatDate2(entry.registrationDate)}
        {/* {entry.registrationDate} */}
      </td>
      <td>
        {entry.startDate && format(new Date(entry.startDate), "MMM. dd, yyy")}
      </td>
      <td>{entry.grade}%</td>
      <td>
        <button
          type="button"
          className="btn-danger btn btn-sm py-0"
          onClick={() => deleteEntry(entry.id)}
        >
          X
        </button>
      </td>
    </tr>
  );
};

export default Entry;
